import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-notice-track",
  "use": "icon-notice-track-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-notice-track\"><path d=\"M25.214 2H4.786A2.789 2.789 0 002 4.786v20.428A2.789 2.789 0 004.786 28h20.428A2.789 2.789 0 0028 25.214V4.786A2.789 2.789 0 0025.214 2zm-9.52 16.515L13.39 20.82l-2.303-2.304-3.152-3.151 2.304-2.304 3.151 3.152 7.774-7.429 2.304 2.304-7.774 7.428z\" fill=\"color(display-p3 .0863 .4471 .9843)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol